import { userService } from '../../helpers/fakebackend/user.service';
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'));
export const state = user
    ? { status: { loggeduser: true }, user }
    : { status: {}, user: null };

// Pull `return_to` off window.location (not $route.query) because we use
// hash history — the query string lives before the `#` and Vue Router
// never sees it. Only honor same-origin backend paths so we can't be used
// as an open redirect.
function readSafeReturnTo() {
    try {
        const raw = new URLSearchParams(window.location.search).get('return_to');
        if (!raw) return null;
        const decoded = decodeURIComponent(raw);
        if (!decoded.startsWith('/') || decoded.startsWith('//')) return null;
        return decoded;
    } catch {
        return null;
    }
}

export const actions = {
    // Resolve the identity provider before asking for a password.
    resolveAccount(_context, email) {
        return userService.resolveAccountType(email);
    },

    // Logs in the user.
    login({ dispatch, commit }, { email, password, forceCc360, accountType, onAuthorizationUrl }) {
        userService.clearClientIdentity();
        commit('loginRequest', { email });

        userService.login(email, password, {
            forceCc360: forceCc360 === true,
            accountType,
            returnTo: (() => {
                const returnTo = readSafeReturnTo();
                return returnTo
                    ? `/?oauth=success&return_to=${encodeURIComponent(returnTo)}#/login`
                    : undefined;
            })(),
            onAuthorizationUrl,
        })
            .then(
                user => {
                    commit('loginSuccess', user);
                    const returnTo = readSafeReturnTo();
                    if (returnTo) {
                        router.push(returnTo);
                        return;
                    }
                    const isInternal = localStorage.getItem('is_internal') === 'true';
                    router.push(isInternal ? '/ramps' : '/');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    verifySession() {
        return userService.verifySession();
    },

    async completeInternalOAuth({ commit, dispatch }) {
        commit('loginRequest', { email: 'oauth' });
        try {
            const profile = await userService.completeInternalOAuth();
            commit('loginSuccess', profile);
            return profile;
        } catch (error) {
            commit('loginFailure', error);
            dispatch('notification/error', 'Internal sign-in could not be completed.', { root: true });
            throw error;
        }
    },

    async resumeInternalSession({ commit, dispatch }) {
        commit('loginRequest', { email: 'session' });
        try {
            const profile = await userService.completeInternalOAuth();
            if (!profile || profile.is_internal !== true) {
                throw 'Internal session is no longer available.';
            }
            commit('loginSuccess', profile);
            return profile;
        } catch (error) {
            commit('loginFailure', error);
            dispatch('notification/error', 'Internal session could not be resumed.', { root: true });
            throw error;
        }
    },

    resetClientSession({ commit }) {
        userService.clearClientIdentity();
        commit('auth/SET_CURRENT_USER', null, { root: true });
        commit('logout');
    },
    // Logout the user
    async logout({ commit }) {
        try {
            await userService.logout();
        } finally {
            userService.clearClientIdentity();
            // The login guard reads this legacy module as well as authfack.
            // Clear both so /login cannot redirect back to an expired session.
            commit('auth/SET_CURRENT_USER', null, { root: true });
            commit('logout');
        }
    },

};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
};

